import React, { useEffect } from 'react';
import { Outlet } from "react-router-dom";


import NavigationComponent from './NavigationComponent';
import FooterComponent from './FooterComponent';

export async function loader({params}){
  return 0;
}

const MainComponent = () => {
  useEffect(() => {
    if(localStorage.getItem("jwt") !== null)
    {
      // todo: Jeżeli w localstorage istnieje jwt to sprawdź usera
    }
  });

  return(
    <React.Fragment>
      <NavigationComponent />
      <div className="mainWrapper">
      <Outlet />
      </div>
      <FooterComponent />
    </React.Fragment>
  )

}
export default MainComponent;